module.exports = __webpack_public_path__ + "img/feliperestrepo.99468f75.jpg";